// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Link, { LinkProps } from "@insite/mobius/Link";
import Typography from "@insite/mobius/Typography";
import React, { FC } from "react";


const ContactTypography: FC<{ targetValue?: string; type: "email" | "phone" } & LinkProps> = props => {
    const target = props.type === "email" ? "mailto:" : "tel:";
    const xProps: LinkProps = {
        href: `${target}${props.targetValue}`,
        onClick: (e: any) => {
            e.defaultPrevented = true; // fix OOTB issue, the telephone/email links not opening
        },
        ...props,
    };

    return <Link {...xProps}>{props.children}</Link>;
};

export default ContactTypography;
